// import { JSEncrypt } from 'encryptlong'
let encryptionList = ['isAttestation']; // 需要加密的内容
const getLocalStorage = (...args) => {
    let storage = {}
    for (let arg of args) {
        if (encryptionList.some(item => item == arg)) {
            let argString = window.localStorage.getItem(arg)
            if(argString==null){
                storage[arg] = ''
            }else {
                storage[arg] = argString || ''
            }
        } else {
            storage[arg] = window.localStorage.getItem(arg) || ''
        }

    }
    return storage
}

const setLocalStorage = (data) => {
    for (let prop in data) {
        if (encryptionList.some(item => item == prop)) {
            window.localStorage.setItem(prop, data[prop])
        } else {
            window.localStorage.setItem(prop, data[prop])
        }

    }
}

const removeLocalStorage = (...args) => {
    for (let arg of args) {
        window.localStorage.removeItem(arg)
    }
}

const debounce = (func, wait) => {
    let timeout, args, context, timestamp, result
    return function() {
        context = this
        args = arguments
        timestamp = new Date()
        const later = () => {
            const last = (new Date()) - timestamp
            if (last < wait) {
                timeout = setTimeout(later, wait - last)
            } else {
                timeout = null
                result = func.apply(context, args)
            }
        }
        if (!timeout) {
            timeout = setTimeout(later, wait)
        }
        return result
    }
}
const throttle = (func, wait, options) => {
    var timeout, context, args, result
    var previous = 0
    if (!options) options = {}

    var later = function() {
        previous = options.leading === false ? 0 : new Date()
        timeout = null
        result = func.apply(context, args)
        if (!timeout) context = args = null // 显示地释放内存，防止内存泄漏
    }

    var throttled = function() {
        var now = new Date()
        if (!previous && options.leading === false) previous = now
        var remaining = wait - (now - previous)
        context = this
        args = arguments
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            previous = now
            result = func.apply(context, args)
            if (!timeout) context = args = null
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining)
        }
        return result
    }

    throttled.cancel = function() {
        clearTimeout(timeout)
        previous = 0
        timeout = context = args = null
    }

    return throttled
}

const getLocationParam = function(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) {
        return decodeURIComponent(r[2])
    }
    return ''
}

const getCookie = () => {
    let cookie = {}
    let str = document.cookie.split(";");
    for (let i = 0; i < str.length; i++) {
        let obj = str[i].split("=");
        if (obj.length != 1) {
            let name = obj[0].replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, '');
            if (name == 'branchName' || name == 'managerUserName') {
                cookie[name] = UrlDecode(obj[1].replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, ''));
            } else {
                cookie[name] = obj[1].replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, '');
            }
        }
    }
    return cookie;
}

function UrlDecode(strAscii) {
    var output = "";
    var posFrom = 0;
    var posTo = strAscii.indexOf("\\u", posFrom);
    while (posTo >= 0) {
        output += strAscii.substring(posFrom, posTo);
        output += toChar(strAscii.substr(posTo, 6));
        posFrom = posTo + 6;
        posTo = strAscii.indexOf("\\u", posFrom);
    }
    output += strAscii.substr(posFrom);
    return output;
}

const toChar = (str) => {
        if (str.substr(0, 2) != "\\u") return str;

        var code = 0;
        for (var i = 2; i < str.length; i++) {
            var cc = str.charCodeAt(i);
            if (cc >= 0x30 && cc <= 0x39)
                cc = cc - 0x30;
            else if (cc >= 0x41 && cc <= 0x5A)
                cc = cc - 0x41 + 10;
            else if (cc >= 0x61 && cc <= 0x7A)
                cc = cc - 0x61 + 10;

            code <<= 4;
            code += cc;
        }

        if (code < 0xff) return str;

        return String.fromCharCode(code);
    }
export {
    getLocalStorage,
    setLocalStorage,
    removeLocalStorage,
    getLocationParam,
    debounce,
    throttle,
    getCookie
}

export default {
    install(Vue) {
        Object.defineProperties(Vue.prototype, {
            $localStorageUtil: {
                value: {
                    getLocalStorage,
                    setLocalStorage,
                    removeLocalStorage,
                    getLocationParam,
                    debounce,
                    throttle,
                    getCookie
                }
            }
        })
    }
}